<template>
  <div id="app">
    <template v-if="$route.path == '/message'">
      <message-view></message-view>
    </template>
    <template v-else>
      <div class="app-bg">
        <header-wrap></header-wrap>
        <router-view />
        <footer-wrap></footer-wrap>
      </div>
    </template>
  </div>
</template>

<script>
import HeaderWrap from "@/components/Header.vue";
import FooterWrap from "@/components/Footer.vue";
import MessageView from "./pages/MessageView.vue";
export default {
  name: "App",
  components: { HeaderWrap, FooterWrap, MessageView },
};
</script>
<style>
#app {
  padding: 0;
  margin: 0;
  height: 100%;
}
.app-bg {
  background: url("../src/assets/images/v3_bg.png") no-repeat top center ,linear-gradient(to bottom, #fdfdff, #fff) ;
  background-size: 100% auto;
}
</style>
